import React from 'react'

function ReceiptFooterStyle() {
  return (
    <style jsx='true'>
    {`
      .footer-container {
        display: flex;
        justify-content: flex-end;
      }

      .action-button-container {
        display: flex;
        padding: 5px;
      }
    `}
    </style>
  )
}

export default React.memo(ReceiptFooterStyle)
